import { connect } from "react-redux";
import OptionFilter from "components/organisms/OptionFilter";
import { filterChange, filterMounted } from "actions";
import { APP_FILTER_TYPES } from "constants/filter";

const mapStateToProps = (state, ownProps) => {
  const name = ownProps.name;
  const filterState = state.filters?.[name] || {};

  return {
    name,
    label: ownProps.label || filterState.label,
    currentValues: filterState.values,
    data: ownProps.options ? ownProps.options : filterState.data || [],
    isMultiSelectFilter: filterState.filterType === APP_FILTER_TYPES.MULTIPLE,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterChange: (name, values) => {
      values = values ? values : [];

      dispatch(filterChange(name, values));
    },
    onMountStateChange: (name, mounted) => {
      dispatch(filterMounted(name, mounted));
    },
  };
};

const OptionFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OptionFilter);

export default OptionFilterContainer;
